<script>
	export let slides = []

	$: activeSlide = null
</script>

<div class="home-slider-wrap">
	{#each slides as slide, i}
		<div
			class="home-slide"
			class:active={slide === activeSlide}
			class:not-active={slide !== activeSlide && activeSlide != null}
			on:mouseenter={() => (activeSlide = slide)}
			on:mouseleave={() => (activeSlide = null)}>
			<div
				class="home-slide-image"
				style="background-image: url({slide.image})" />
			<div
				class="home-slide-color"
				style="background-color:{slide.color_overlay}" />
			<div
				class:active={slide === activeSlide}
				class="home-slide-gradient"
				style="background: linear-gradient(90deg, {slide.color_overlay} 65%,
				rgba(255,255,255,0) 100%);" />
			<div class="main">
				<div
					class="inner-wrap"
					data-sal="slide-up"
					data-sal-duration="500"
					data-sal-delay={i * 150}>
					<div class="home-slide-title">
						<h2>{slide.title}</h2>
					</div>
					<div class="home-slide-content">
						<span style="color: {slide.color_overlay}">{slide.title}</span>
						{@html slide.content}
						{#if slide.button_link}
							<a href={slide.button_link} class="paint-btn">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									xmlns:xlink="http://www.w3.org/1999/xlink"
									x="0"
									y="0"
									viewBox="0 0 403.9 450"
									xml:space="preserve">
									<path
										class="st0"
										d="M384.1 0H62.2C51.3 0 42.4 8.9 42.4 19.8v62.3c0 10.9 8.9
										19.8 19.8 19.8h321.9c10.9 0 19.8-8.9 19.8-19.8V19.8C403.9
										8.9 395 0 384.1 0"
										fill={slide.color_overlay} />
									<path
										class="st0"
										d="M234.1 209.8v-87.2H18.2V60.7h18.2V41.2H0v103h214l-1.2
										65.2c-6.5 3.3-10.9 9.9-10.9 17.7v203c0 10.9 8.9 19.8 19.8
										19.8h2.9c10.9 0 19.8-8.9
										19.8-19.8v-203c0-7.4-4.2-13.9-10.3-17.3"
										fill={slide.color_overlay} />
								</svg>
								{slide.button_text}
							</a>
						{/if}
					</div>
				</div>
			</div>
		</div>
	{/each}
</div>
